
  <!--<b-tabs>
  <b-tab title="Uppdateringslogg">
  -->
  <div>
      <b-row style="max-height: 88vh; overflow-y: scroll">
          <b-col cols="8">
              <b-card-group
                  v-for="d in changelog"
                  v-bind:key="'updates_on_' + d.date"
              >
                  <b-card :header="d.date | formatChangeLogDate">
                      <b-list-group
                          v-for="c in d.changes"
                          v-bind:key="'update_' + c.id"
                      >
                          <span v-if="c.type == 'version'">
                              <h3>{{ c.description }}</h3>
                          </span>
                          <b-list-group-item v-else>
                              <span v-if="c.type == 'fix'">
                                  <b>Buggfix: </b>
                              </span>
                              <span v-html="c.description"></span>
                              <span
                                  class="float-right"
                                  v-if="c.type != 'minor' && c.action != null"
                              >
                                  <small>Åtgärd: {{ c.action }}</small>
                              </span>
                          </b-list-group-item>
                      </b-list-group>
                  </b-card>
              </b-card-group>
              <hr />
              <h2>Uppdateringar äldre än {{ older.before | formatChangeLogDate }}</h2>
              <hr />
                    <b-list-group
                          v-for="c in older.changes"
                          v-bind:key="'update_' + c.id"
                      >
                      <b-list-group-item>
                              <span v-if="c.type == 'fix'">
                                  <b>Buggfix: </b>
                              </span>
                              <span v-html="c.description"></span>
                              <span
                                  class="float-right"
                                  v-if="c.type != 'minor' && c.action != null"
                              >
                              </span>
                          </b-list-group-item>
                      </b-list-group>
          </b-col>
          <b-col>

      <p class="lead">
          <br />
          Här listas uppdateringar, ändringar och buggfixar som gjorts i
          programmet eller distanstolkningstjänsten.
      </p>

      <b-alert show variant="warning" v-if="error && !desktop">
          Kunde inte hämta aktuell uppdateringslogg. Visar senast hämtade.
      </b-alert>
          </b-col>
      </b-row>
      </div>
      <!--</b-tab>
  <b-tab title="Version">
    <b-overlay :show="loading">
      <b-jumbotron>
        Du använder STTylus version:
        <code>{}</code>
        <br />Den senaste tillgängliga versionen av programmet är:
        <code>{}</code>
        <br />
      </b-jumbotron>
    </b-overlay>
  </b-tab>
</b-tabs>
-->
  </div>
